if (!window.swatchPickerInitialized) {
  window.swatchPickerInitialized = true;

  const initSwatchGroup = (fieldset) => {
    if (fieldset.dataset.swatchInitialized === 'true') return;
    fieldset.dataset.swatchInitialized = 'true';

    const group = fieldset.querySelector('[data-swatch-group]');
    const selectedNameEl = fieldset.querySelector('[data-swatch-selected-name]');
    if (!group || !selectedNameEl) return;

    // Swatches may live in more than one container (e.g. the visible row
    // plus an accordion panel), so selection lookups are scoped to the
    // whole fieldset rather than just the first [data-swatch-group].
    const getCheckedName = () => {
      const checkedInput = fieldset.querySelector('.swatch-input:checked');
      if (!checkedInput) return '';
      const checkedLabel = fieldset.querySelector(`label[for="${checkedInput.id}"]`);
      return checkedLabel ? checkedLabel.dataset.swatchName : '';
    };

    const showSelectedName = () => {
      selectedNameEl.textContent = getCheckedName();
    };

    fieldset.addEventListener('change', showSelectedName);
    showSelectedName();

    // Shows a small tooltip below whichever swatch the user is hovering
    // (or has keyboard-focused), confirming its name. Built as a single
    // element reused across swatches (not one per swatch) and appended to
    // the hovered label, so it works identically whether the swatch lives
    // in the visible row or the accordion panel, and doesn't touch native
    // variant markup. Merchant-controlled via the "Show name tooltip on
    // hover" theme setting.
    if (fieldset.dataset.tooltipEnable === 'true') {
      const getTooltip = () => {
        let tooltip = fieldset.querySelector('[data-swatch-hover-tooltip]');
        if (!tooltip) {
          tooltip = document.createElement('span');
          tooltip.className = 'swatch-click-tooltip';
          tooltip.setAttribute('data-swatch-hover-tooltip', '');
          tooltip.setAttribute('role', 'status');
        }
        return tooltip;
      };

      fieldset.querySelectorAll('.swatch-label').forEach((label) => {
        const showTooltip = () => {
          const tooltip = getTooltip();
          tooltip.textContent = label.dataset.swatchName || '';
          label.appendChild(tooltip);
        };
        const hideTooltip = () => {
          const tooltip = fieldset.querySelector('[data-swatch-hover-tooltip]');
          if (tooltip) tooltip.remove();
        };

        label.addEventListener('mouseenter', showTooltip);
        label.addEventListener('mouseleave', hideTooltip);
        label.addEventListener('focus', showTooltip);
        label.addEventListener('blur', hideTooltip);
      });
    }

    const updateScrollable = () => {
      group.classList.remove('swatch-group--scrollable');
      const isOverflowing = group.scrollWidth > group.clientWidth + 1;
      group.classList.toggle('swatch-group--scrollable', isOverflowing);
    };

    updateScrollable();

    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => updateScrollable());
      resizeObserver.observe(group);
    } else {
      window.addEventListener('resize', updateScrollable);
    }

    group.addEventListener(
      'wheel',
      (event) => {
        if (!group.classList.contains('swatch-group--scrollable')) return;
        if (event.deltaY === 0) return;
        event.preventDefault();
        group.scrollLeft += event.deltaY;
      },
      { passive: false }
    );
  };

  // Non-color ("pill") accordion options show the currently selected value
  // in their legend the same way color swatches do, but pills have no
  // swatch-specific data-swatch-name attribute - the value lives on the
  // native radio input's `value` attribute, so selection is read from
  // there instead.
  const initPillAccordionGroup = (fieldset) => {
    if (fieldset.dataset.pillInitialized === 'true') return;
    fieldset.dataset.pillInitialized = 'true';

    const selectedNameEl = fieldset.querySelector('[data-pill-selected-name]');
    if (!selectedNameEl) return;

    const showSelectedValue = () => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      selectedNameEl.textContent = checkedInput ? checkedInput.value : '';
    };

    fieldset.addEventListener('change', showSelectedValue);
    fieldset.addEventListener('click', (event) => {
      if (event.target.closest('input[type="radio"]')) {
        showSelectedValue();
      }
    });

    showSelectedValue();

    // Same hover/focus tooltip behavior as color swatches, for a
    // consistent experience across variant types. Pill labels have no
    // data-swatch-name, so the name comes from the paired input's value.
    // Merchant-controlled via the "Show name tooltip on hover" setting.
    if (fieldset.dataset.tooltipEnable === 'true') {
      const getTooltip = () => {
        let tooltip = fieldset.querySelector('[data-pill-hover-tooltip]');
        if (!tooltip) {
          tooltip = document.createElement('span');
          tooltip.className = 'swatch-click-tooltip';
          tooltip.setAttribute('data-pill-hover-tooltip', '');
          tooltip.setAttribute('role', 'status');
        }
        return tooltip;
      };

      fieldset.querySelectorAll('input[type="radio"] + label').forEach((label) => {
        const input = document.getElementById(label.getAttribute('for'));
        if (!input) return;

        const showTooltip = () => {
          const tooltip = getTooltip();
          tooltip.textContent = input.value || '';
          label.appendChild(tooltip);
        };
        const hideTooltip = () => {
          const tooltip = fieldset.querySelector('[data-pill-hover-tooltip]');
          if (tooltip) tooltip.remove();
        };

        label.addEventListener('mouseenter', showTooltip);
        label.addEventListener('mouseleave', hideTooltip);
        label.addEventListener('focus', showTooltip);
        label.addEventListener('blur', hideTooltip);
      });
    }
  };

  const initAllSwatchGroups = () => {
    document.querySelectorAll('[data-option-is-color]').forEach(initSwatchGroup);
    document.querySelectorAll('[data-option-is-pill-accordion]').forEach(initPillAccordionGroup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSwatchGroups);
  } else {
    initAllSwatchGroups();
  }

  document.addEventListener('shopify:section:load', initAllSwatchGroups);
}
